import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { OrderChecklistData } from '../../../../../../models/order/workflow/order-checklist.model';


@Injectable({ providedIn: 'root' })
export class OrderChecklistStateService extends BaseWorkflowStateService<OrderChecklistData> {
    override stateKey: string = 'orderChecklist';
}